<div class="modal-body">
  <app-tabs>
    <app-tab [tabTitle]="'General'" class="tab-cls">
      <div class="col-sm-12 case-info-container">
        <div class="col-sm-12 case-info-panel">
          <div>
            {{ 'Name' | translate }}:
            <strong>{{ provider?.name }}</strong>
          </div>
          <div>
            {{ 'Contact Name' | translate }}:
            <strong>{{ provider?.contact_name }}</strong>
          </div>
          <div>
          {{ 'Contact Phones' | translate }}:
            <strong>{{ provider?.contact_phones }}</strong>
          </div>
          <div>
            {{ 'Contact Emails' | translate }}:
            <strong>{{ provider?.contact_emails }}</strong>
          </div>
          <div>
            {{ 'Address' | translate }}:
            <strong>{{ provider?.address }}</strong>
          </div>
          <div>
            {{ 'Coverage Area' | translate }}:
            <strong>{{ provider?.coverage_area }}</strong>
          </div>
        </div>
      </div>
    </app-tab>
    <app-tab [tabTitle]="'Delegación'" class="tab-cls">
      <div class="col-sm-12 case-info-container">
        <div class="col-sm-12 case-info-panel">
          <hr>
          <h4>{{ 'Provider Site' | translate }}</h4>
          <!-- <div>
            {{ 'Site code' | translate }}:
            <strong>{{ provider_site?.equivalence_id }}</strong>
          </div> -->
          <div>
            {{ 'Name' | translate }}:
            <strong>{{ provider_site?.site }}</strong>
          </div>
        </div>
      </div>
    </app-tab>
    <app-tab [tabTitle]="'Cobertura'" class="tab-cls">
      <div class="col-sm-12 case-info-container">
        <div class="col-sm-12 case-info-panel">
          <hr>
          <h4>{{ 'Coverage' | translate }}</h4>
          <div *ngIf="coverage?.coverage_type == 1">
            {{ 'Plane' | translate }}:
            <strong>Plano {{ coverage?.plane }}</strong>
          </div>
          <div *ngIf="coverage?.coverage_type == 2">
            {{ 'Plane' | translate }}:
            <strong>Carretero</strong>
          </div>
          <div *ngIf="coverage?.coverage_type == 2">
            {{ 'Distance' | translate }} (Km):
            <strong>{{ coverage?.distance }}</strong>
          </div>
        </div>
      </div>
    </app-tab>

    <!-- PRICES -->
    <app-tab [tabTitle]="'Precios'" class="tab-cls">
      <div class="col-sm-12 case-info-container">
        <div class="col-sm-12 case-info-panel">
          <hr>
          <h4>{{ 'Prices' | translate }}</h4>
          <div *ngIf="coverage?.coverage_type == 1">
            {{ 'Base Price' | translate }}:
            <strong>{{ provider?.currency_symbol }} {{ prices?.price_weekday | number: "1.2-2" }}</strong>
          </div>
          <div *ngIf="coverage?.coverage_type == 2">
            {{ 'Kilometers Price' | translate }}:
            <strong>{{ provider?.currency_symbol }} {{ prices?.price_weekday | number: "1.2-2" }}</strong>
          </div>
          <div *ngIf="coverage?.coverage_type == 2">
            {{ 'Price Flag' | translate }}:
            <strong>{{ provider?.currency_symbol }} {{ prices?.price_flag | number: "1.2-2" }}</strong>
          </div>
          <div>
            {{ 'Price Cancellation' | translate }}:
            <strong>{{ provider?.currency_symbol }} {{ prices?.price_cancellation | number: "1.2-2" }}</strong>
          </div>

          <div>
            {{ 'Notes' | translate }}:
            <strong>{{ prices?.note }}</strong>
          </div>

        </div>
      </div>
    </app-tab>
    <div class="form-group">
        <button type="submit" class="btn primary-btn btn primary-btn-fw " (click)="ReassignProvider(sent_service_id)">{{ 'Reassign Provider' | translate }}</button>
    </div>
  </app-tabs>
</div>
    
  <p-dialog
  header="{{ 'Reassign Provider' | translate }}" [(visible)]="showReassignProviderDialog"
  [responsive]="true" [modal]="true" [draggable]="false"
  [breakpoint]="500" [blockScroll]="true">
  <app-assistance-reassign-provider
  [service]="service_id"
  [providers]="providers_re"
  [case_id]="case_id"
  #newForm>
  </app-assistance-reassign-provider>
</p-dialog>